import { create } from 'zustand'

import { integrationService } from '@/modules/integrations/services'
import type {
  IntegrationConfig,
  IntegrationDashboard,
  IntegrationHealth,
  IntegrationLog,
} from '@/modules/integrations/entities'

interface IntegrationStoreState {
  ready: boolean
  health: IntegrationHealth[]
  dashboard: IntegrationDashboard
  logs: IntegrationLog[]
  config: IntegrationConfig

  hydrate: () => Promise<void>
  refreshHealth: () => Promise<void>
  updateConfig: (patch: Partial<IntegrationConfig>) => void
  refreshLogs: (supplierId?: string) => void
}

export const useIntegrationStore = create<IntegrationStoreState>((set) => ({
  ready: false,
  health: [],
  dashboard: {
    averageLatency: 0,
    maxLatency: 0,
    unavailableCount: 0,
    cacheHitRate: 0,
    suppliers: [],
  },
  logs: [],
  config: integrationService.getConfig(),

  hydrate: async () => {
    await integrationService.bootstrap()
    set({
      ready: true,
      health: integrationService.listHealth(),
      dashboard: integrationService.dashboard(),
      logs: integrationService.logs(),
      config: integrationService.getConfig(),
    })
  },

  refreshHealth: async () => {
    const health = await integrationService.refreshHealth()
    set({
      health,
      dashboard: integrationService.dashboard(),
      logs: integrationService.logs(),
    })
  },

  updateConfig: (patch) => {
    const config = integrationService.updateConfig(patch)
    set({ config })
  },

  refreshLogs: (supplierId) => {
    set({ logs: integrationService.logs(supplierId) })
  },
}))
